<script lang="ts">
    import KpPopover from 'shared/ui-widgets/popover/KpPopover.svelte';
    import ThreadContent from 'src/features/threads/shared-components/ThreadContent.svelte';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';
    import ThreadsList from 'src/features/threads/popover/components/ThreadsList.svelte';
</script>

<KpPopover buttonSize="md"
           placement="bottom-end"
           buttonStyle="default"
           additionalPopoverClasses="kp-threads-popover"
           additionalPopoverPanelClasses="kp-threads-popover-panel"
           additionalClasses="kp-threads-popover-button">

    <UIcon slot="button" icon="messages"/>

    <div slot="popover-content" class="kp-threads-popover-content">
        <ThreadsList/>
        <ThreadContent placement="popover"/>
    </div>
</KpPopover>

<style lang="less">
    @import (reference) "styles/portaro.themes.less";
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro-erp.less";

    .kp-threads-popover-content {
        padding: @spacing-s 0;
        display: flex;
        flex-direction: column;
        gap: @spacing-m;
    }

    :global {
        .kp-threads-popover {
            .kp-popover-animation-container {
                height: 100%;
            }

            .popover {
                margin-top: @spacing-s;
                background-color: @themed-body-bg;
                border-radius: @border-radius-large;
                border: 1px solid @themed-border-default;

                .popover-content {
                    display: flex;
                    flex-direction: column;
                    background-color: @themed-body-bg;
                    padding: 0;
                    height: 100%;

                    .kp-threads-popover-content {
                        .flex-grow();
                        padding: 0;
                        gap: 0;
                    }
                }
            }
        }

        .kp-threads-popover-panel {
            width: 700px;
            height: 900px;
            max-width: 90vw;
            max-height: 90vh;
        }
    }
</style>